import { useMemo } from 'react';
import { TransitionMoveDirection } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Animations/Transitions/Transitions.types';
import { TransitionPropertyOptions } from './TransitionPropertyOptions';
import Icon from '@/components/atoms/Icon';

const size = 20;

export const TransitionMove = ({
  selectedValue,
  onChange,
  disabled
}: {
  selectedValue: TransitionMoveDirection | null;
  onChange: (value: TransitionMoveDirection) => void;
  disabled: boolean;
}) => {
  const options = useMemo(() => {
    return [
      { Icon: <Icon name="IconArrowNarrowUp" size={size} />, value: TransitionMoveDirection.UP },
      { Icon: <Icon name="IconArrowNarrowDown" size={size} />, value: TransitionMoveDirection.DOWN },
      { Icon: <Icon name="IconArrowNarrowRight" size={size} />, value: TransitionMoveDirection.RIGHT },
      { Icon: <Icon name="IconArrowNarrowLeft" size={size} />, value: TransitionMoveDirection.LEFT }
    ];
  }, []);
  return (
    <div className="flex flex-1 flex-col">
      <div className="mb-1 mt-2.5 select-none text-xs font-medium text-[#A5A9AD]">Direction</div>
      <TransitionPropertyOptions
        disabled={disabled}
        options={options}
        onClick={onChange as any}
        selectedValue={selectedValue}
      />
    </div>
  );
};
